<app-header></app-header>

<div class="verify-page">
  <div class="page-body">

    <!-- LEFT PANEL (mirrors login exactly) -->
    <section class="left">
      <div class="shimmer"></div>
      <div class="pts" aria-hidden="true"></div>
      <div class="left-in">
        <div class="brand-top">
          <img class="brand-logo" src="../../assets/NEXGEN Logo final for footer.png"
            alt="NexGen Executive Coaching Academy Logo" routerLink="/home" />
        </div>

        <h1 class="l-h1">
          Almost there.<br />
          <em>Payment in progress.</em>
        </h1>

        <p class="l-body">
          We're confirming your payment securely.<br />
          <strong>Your spot will be reserved once verification is complete.</strong>
        </p>

        <div class="steps">
          <div class="step">
            <div class="sn">1</div>
            <div class="st"><strong>Payment submitted</strong> — your card was charged via Stripe's secure gateway.
            </div>
          </div>
          <div class="step">
            <div class="sn">2</div>
            <div class="st"><strong>Verification in progress</strong> — we're confirming your payment and reserving your
              spot.</div>
          </div>
          <div class="step">
            <div class="sn">3</div>
            <div class="st">
              <strong>Confirmation sent</strong> — check your email for your login credentials to access your learning
              path.
            </div>
          </div>
        </div>

        <div class="l-foot">
          Need help with your payment?<br />
          Email us: <a href="mailto:support@nexgencoaches.com">support@nexgencoaches.com</a>
        </div>
      </div>
    </section>

    <!-- RIGHT PANEL -->
    <section class="right">
      <div class="fw">

        <div class="fey">Payment Verification</div>

        <h2 class="fh2">
          Confirm your<br />
          <em>Registration.</em>
        </h2>

        <p class="fsub">Verifying your payment.</p>

        <!-- Loading State -->
        <div *ngIf="verificationStatus === 'loading'" class="status-block loading-block">
          <div class="spinner-wrap">
            <div class="spinner-ring"></div>
          </div>
          <h3 class="status-title">Verifying Payment...</h3>
          <p class="status-sub">Please wait while we confirm your payment.</p>
        </div>

        <!-- Success State -->
        <div *ngIf="verificationStatus === 'success'" class="status-block success-block">
          <div class="status-icon success-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>
          <h3 class="status-title">Payment Successful!</h3>
          <p class="status-sub">Your payment has been verified. Redirecting you to login...</p>
          <div class="gold-bar-static"></div>
        </div>

        <!-- Failed / Error / Manual Entry State -->
        <div *ngIf="verificationStatus === 'failed' || verificationStatus === 'error' || !sessionId"
          class="status-block error-block">

          <div *ngIf="verificationStatus === 'failed' || verificationStatus === 'error'" class="status-icon error-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>

          <h3 class="status-title" *ngIf="verificationStatus === 'failed' || verificationStatus === 'error'">
            Payment Verification Failed
          </h3>
          <h3 class="status-title"
            *ngIf="!sessionId && verificationStatus !== 'failed' && verificationStatus !== 'error'">
            Enter Session ID
          </h3>
          <p class="status-sub" *ngIf="!sessionId && verificationStatus !== 'failed' && verificationStatus !== 'error'">
            Please enter your session ID to verify your payment.
          </p>

          <form (ngSubmit)="onVerifySession()" #verifyForm="ngForm">
            <div class="field">
              <label for="sessionId">
                Session ID <span class="required">*</span>
              </label>
              <input type="text" id="sessionId" name="sessionId" [(ngModel)]="manualSessionId"
                placeholder="Enter your session ID" required #sessionIdInput="ngModel" [disabled]="isVerifying"
                [class.err]="sessionIdInput.invalid && (sessionIdInput.touched || submitted)" />
              <div class="inline-err" *ngIf="sessionIdInput.invalid && (sessionIdInput.touched || submitted)">
                Session ID is required.
              </div>
            </div>

            <button type="submit" class="btn-primary" [disabled]="isVerifying || sessionIdInput.invalid">
              <span *ngIf="!isVerifying">Verify Session</span>
              <span *ngIf="isVerifying" class="btn-spinner-row">
                <span class="btn-spinner"></span> Verifying…
              </span>
            </button>
            <div class="gold-bar"></div>
          </form>

          <div class="action-row">
            <button type="button" class="btn-secondary" (click)="retryPayment()">
              Retry Payment
            </button>
            <button type="button" class="btn-secondary" (click)="goToHome()">
              Go to Home
            </button>
          </div>
        </div>

      </div>
    </section>

  </div>
</div>

<app-bottomside></app-bottomside>



<!-- No-Payment Alert Overlay -->
<div class="np-overlay" *ngIf="showNoPaymentAlert">
  <div class="np-backdrop"></div>
  <div class="np-modal">
    <div class="np-icon-wrap">
      <div class="np-icon-ring"></div>
      <svg class="np-icon" xmlns="http://www.w3.org/2000/svg" width="32" height="32"
        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"/>
        <line x1="12" y1="8" x2="12" y2="12"/>
        <line x1="12" y1="16" x2="12.01" y2="16"/>
      </svg>
    </div>

    <p class="np-eyebrow">Access Denied</p>
    <h2 class="np-title">No Payment Found</h2>
    <p class="np-body">
      You haven't completed a payment. <br/>
      You'll be redirected to the home page automatically.
    </p>

    <div class="np-timer-bar-wrap">
      <div class="np-timer-label">Redirecting in <span class="np-countdown">{{ redirectCountdown }}s</span></div>
      <div class="np-timer-track">
        <div class="np-timer-fill" [style.width.%]="timerProgress"></div>
      </div>
    </div>

    <button class="np-btn" (click)="redirectNow()">
      Take Me Home Now
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round">
        <line x1="5" y1="12" x2="19" y2="12"/>
        <polyline points="12 5 19 12 12 19"/>
      </svg>
    </button>
  </div>
</div>